/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinqrenlarge2Inputs */

const en_checkinqrenlarge2 = /** @type {(inputs: Checkinqrenlarge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the code large`)
};

const de_checkinqrenlarge2 = /** @type {(inputs: Checkinqrenlarge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code groß anzeigen`)
};

/**
* | output |
* | --- |
* | "Show the code large" |
*
* @param {Checkinqrenlarge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinqrenlarge2 = /** @type {((inputs?: Checkinqrenlarge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinqrenlarge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinqrenlarge2(inputs)
	return de_checkinqrenlarge2(inputs)
});
export { checkinqrenlarge2 as "checkinQrEnlarge" }